import { render, staticRenderFns } from "./jshop.vue?vue&type=template&id=622a9c5e"
import script from "./jshop.vue?vue&type=script&lang=js"
export * from "./jshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports